// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Clamp card description to 4 lines with ellipsis */
.card__text--clamp {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  min-height: 5.2em; /* Ensures card height is consistent for 4 lines */
}

.body {
  gap: 20px;
  width: 100%;
  padding: 20px;
  background: rgba(234, 229, 229, 0.172);
  border-radius: 12px;
  margin-top: 20px;
}

@media (max-width: 1024px) {
  .body {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .body {
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .body {
    gap: 10px;
    padding: 0;
  }
}

/* Input Fields Container */

.inputFields {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

@media (max-width: 1024px) {
  .inputFields {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .inputFields {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .inputFields {
    width: 100%;
  }
}

/* select options  */
.select-container {
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .select-container {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .select-container {
    width: 100%;
  }
}

.form {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 15px;
  width: 100%;
}

@media (max-width: 768px) {
  .form {
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .form {
    gap: 10px;
  }
}

.form select {
  width: 100%;
  padding: 15px;
  padding-left: 10px;
  background-color: #fff;
  border-radius: 10px;
  border: none;
  outline: none;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .form select {
    padding: 12px 10px;
  }
}

@media (max-width: 480px) {
  .form select {
    padding: 10px 8px;
  }
}

.modal-tags-container {
  width: 100%;
}

.modal-tags-container .addbtn {
  display: flex;
  gap: 10px;
  width: 100%;

  @media (max-width: 480px) {
    flex-direction: column;
  }
}

.modal-tags-container .addbtn input {
  flex: 1 1;

  @media (max-width: 480px) {
    width: 100%;
  }
}

.modal-tags-container .addbtn button {
  padding: 10px 20px;
  border-radius: 30px;
  border: none;
  background: #004996;
  color: white;
  cursor: pointer;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);

  @media (max-width: 480px) {
    width: 100%;
  }
}
/* -------------------- */

.form-header {
  display: flex;
  gap: 20px;
  align-items: center;

  @media (max-width: 768px) {
    /* flex-direction: column; */
    align-items: stretch;
    gap: 15px;
  }

  @media (max-width: 360px) {
    align-items: flex-start;
    flex-direction: column;
  }
}

.videoContainer {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  width: 100%;
  padding: 20px;
  height: fit-content;
  margin-top: 10px;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .videoContainer {
    padding: 15px;
    border-radius: 20px;
  }
}

@media (max-width: 480px) {
  .videoContainer {
    padding: 12px;
    border-radius: 15px;
  }
}

.videoContainer h1 {
  text-align: left;
}

.videoContainer .bulk-video-grid {
  justify-content: flex-start;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
  margin-bottom: 20px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 12px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}
.uploadSection {
  display: flex;
  /* gap: 20px; */
  flex-wrap: wrap;
  margin-top: 20px;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
}

@media (max-width: 1024px) {
  .uploadSection {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 768px) {
  .uploadSection {
    gap: 15px;
    margin-top: 15px;
  }
}

@media (max-width: 480px) {
  .uploadSection {
    gap: 10px;
    margin-top: 10px;
  }
}
.fileUpload {
  background: #ffffff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  width: 100%;
  /* max-width: 800px; */
  padding: 0;
  height: fit-content;
  margin-top: 10px;
  position: relative;
  box-sizing: border-box;
}
.radioBtns{
  display: flex;

  @media (max-width: 370px) {
    flex-direction: column;
  display: block;

  }
}
@media (max-width: 768px) {
  .fileUpload {
    border-radius: 10px;
  }
}

@media (max-width: 480px) {
  .fileUpload {
    border-radius: 8px;
    margin-top: 5px;
  }
}
.upArea {
  display: flex;
  align-items: center;

  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
}
.fileUpload .upload-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px 15px;
  border-bottom: 1px solid #f3f4f6;
}

.fileUpload .upload-header h1 {
  margin: 0;
  color: #1a1a1a;
}

.fileUpload .close-btn {
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fileUpload .close-btn:hover {
  color: #1a1a1a;
}

.fileUpload .file-type-selector {
  padding: 15px 25px;
}

.fileUpload .file-type-selector label {
  display: block;
  color: #9ca3af;
  margin-bottom: 10px;
}

.fileUpload .radio-group {
  display: flex;
  gap: 20px;
}

.fileUpload .radio-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
}

.fileUpload .radio-option input[type="radio"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  margin: 0;
  accent-color: #004996;
}

.fileUpload .radio-option span {
  color: #1a1a1a;
}

.fileUpload .upload-area {
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  background: #ffffff;
  margin: 15px 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.fileUpload .upload-area:hover {
  border-color: #004996;
  background: #fafafa;
}

.fileUpload .upload-area::after {
  content: "";
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 5px;
}

.fileUpload .upload-area .plus-icon {
  color: #1a1a1a;
  margin-bottom: 8px;
  font-weight: 300;
}

.fileUpload .upload-area p {
  color: #1a1a1a;
  margin: 5px 0;
}

.fileUpload .upload-area .file-info {
  color: #9ca3af;
}

.fileUpload .file-list {
  padding: 0 25px;
  margin: 20px 0;
  max-height: 280px;
  overflow-y: scroll;
  width: calc(100% - 50px);
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 1200px) {
    width: 100%;
  }
  @media (max-width: 767px) {
    width: 100%;
    grid-template-columns: 1fr;
  }
}

.fileUpload .file-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 12px 15px;
  background: #fafafa;
  border-radius: 8px;
  margin-bottom: 10px;
  border: 1px solid #f0f0f0;
}

.fileUpload .file-item .file-info-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex: 1 1;
}

.fileUpload .file-item .file-icon {
  margin-top: 2px;
}

.fileUpload .file-item .file-details {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1 1;
}

.fileUpload .file-item .file-name {
  color: #1a1a1a;
  font-weight: 500;
  margin: 0;
}

.fileUpload .file-item .file-meta {
  display: flex;
  gap: 8px;
  color: #9ca3af;
}

.fileUpload .file-item .file-size {
  color: #9ca3af;
}

.fileUpload .file-item .file-progress {
  color: #1a1a1a;
  font-weight: 500;
}

.fileUpload .file-item .file-time {
  color: #9ca3af;
}

.fileUpload .file-item .file-status-text {
  color: #10b981;
  font-weight: 500;
}

.fileUpload .file-item .file-status-text.error {
  color: #ef4444;
}

.fileUpload .progress-bar {
  width: 100%;
  height: 4px;
  background: #e5e7eb;
  border-radius: 2px;
  overflow: hidden;
  margin-top: 3px;
}

.fileUpload .progress-fill {
  height: 100%;
  background: #18a103;
  transition: width 0.3s ease;
}

.fileUpload .file-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.fileUpload .retry-btn {
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.fileUpload .retry-btn:hover {
  color: #1a1a1a;
}

.fileUpload .delete-btn {
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.fileUpload .delete-btn:hover {
  color: #ef4444;
}

.button-group {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 20px 25px;
  border-top: 1px solid #f3f4f6;
  margin-top: 10px;

  @media(max-width: 600px) {
    flex-direction: column;
  }
}

.button-group .cancel-btn {
  background: #ffffff;
  color: #6b7280;
  padding: 10px 30px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
}

.fileUpload .button-group .cancel-btn:hover {
  background: #f9fafb;
  border-color: #d1d5db;
}

.fileUpload .button-group .save-btn {
  background: #004996;
  color: #ffffff;
  padding: 10px 40px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.fileUpload .button-group .save-btn:hover {
  background: #004996;
}
.UploadImages {
  background: #ffffff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  width: 100%;
  padding: 20px;
  height: fit-content;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .UploadImages {
    padding: 15px;
    border-radius: 20px;
  }
}

@media (max-width: 480px) {
  .UploadImages {
    padding: 12px;
    border-radius: 15px;
  }
}

.bulkThumbnail h1 {
  margin-bottom: 15px;
}

.bulkUpload {
  width: 100%;
  display: flex;
  flex-direction: column;
}
/* upload thumbnail image css */
.container {
  max-width: 960px;
  margin: 30px auto;
  /* padding: 20px; */
  text-align: left;
}

h1 {
  text-align: left;
  margin: 20px 0 20px;
  small {
    display: block;
    padding-top: 8px;
    color: gray;
  }
}

.avatar-upload {
  position: relative;
  width: 120px;
  height: 120px;
  margin: 50px auto;

  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
    margin: 20px auto;
  }

  @media (max-width: 480px) {
    width: 90px;
    height: 90px;
    margin: 15px auto;
  }
  .avatar-edit {
    position: absolute;
    right: -10px;
    z-index: 1;
    top: -10px;
    input {
      display: none;
      + label {
        display: inline-block;
        width: 34px;
        height: 34px;
        margin-bottom: 0;
        border-radius: 100%;
        background: #ffffff;
        border: 1px solid transparent;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
        cursor: pointer;
        font-weight: normal;
        transition: all 0.2s ease-in-out;
        &:hover {
          background: #f1f1f1;
          border-color: #d6d6d6;
        }
        &:after {
          content: "\\f040";
          font-family: "FontAwesome";
          color: #757575;
          position: absolute;
          top: 10px;
          left: 0;
          right: 0;
          text-align: center;
          margin: auto;
        }
      }
    }
  }
  .avatar-preview {
    width: 120px;
    height: 120px;
    position: relative;
    border: 1px dashed #004996;
    border-radius: 30px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);

    @media (max-width: 768px) {
      width: 100px;
      height: 100px;
      border-radius: 20px;
    }

    @media (max-width: 480px) {
      width: 90px;
      height: 90px;
      border-radius: 15px;
    }
    > div {
      width: 100%;
      height: 100%;
      border-radius: 30px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
}

/*  */

.body form {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.body form input {
  /* height: 50px; */
  border-radius: 10px;
  border: none;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  padding: 15px;
  width: 100%;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .body form input {
    height: 45px;
    padding: 15px;
    border-radius: 20px;
  }
}

@media (max-width: 480px) {
  .body form input {
    height: 42px;
    padding: 12px;
    border-radius: 15px;
  }
}

/* @media (max-width: 480px) {
  .body form input {
    height: 42px;
    padding: 12px;
    border-radius: 20px;
  }
} */

.body form label {
  margin-top: 10px;
}

.body form .label {
  margin-top: 20px;
}

.body form textarea {
  border-radius: 20px;
  border: none;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 100%;
  /* max-width: 800px; */
  resize: vertical;
  font-family: inherit;
  box-sizing: border-box;
}

@media (max-width: 1024px) {
  .body form textarea {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .body form textarea {
    padding: 15px;
    border-radius: 15px;
  }
}

@media (max-width: 480px) {
  .body form textarea {
    padding: 12px;
    border-radius: 12px;
  }
}

.body form .description {
  margin-top: 20px;
}

/* PRODUCT DETAIL PAGE CSS */

.product-detail-container {
  display: grid;
  gap: 30px;
  margin: 20px;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 320px), 1fr));
  width: clamp(300px, 90%, 1520px);
  margin: 0 auto;

  @media (max-width: 1024px) {
    justify-items: center;
    margin-top: 20px;
    width: 95%;
    gap: 20px;
    grid-template-columns: repeat(1, 1fr);
  }

  @media (max-width: 768px) {
    width: 100%;
    margin: 0;
    padding: 10px;
    gap: 15px;
  }

  @media (max-width: 480px) {
    padding: 5px;
    gap: 10px;
  }
}

.product-detail-container .frame-one {
  max-width: 680px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  padding: 20px;
  width: 100%;
  background: #ffffff;
  height: fit-content;
}

@media (max-width: 768px) {
  .product-detail-container .frame-one {
    padding: 15px;
    border-radius: 20px;
  }
}

@media (max-width: 480px) {
  .product-detail-container .frame-one {
    padding: 12px;
    border-radius: 15px;
  }
}

.product-detail-container .frame-one img {
  margin: 0 auto;
  width: 100%;
  /* Clip only top right and bottom left corners */
  clip-path: polygon(0% 0%, 80% 0%, 100% 17%, 100% 100%, 17% 100%, 0% 80%);
}

.product-detail-container .frame-one .content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
}

.product-detail-container .frame-one .description {
  margin-top: 20px;
}

p {
  color: #000000;
}

.product-detail-container .frame-two {
  max-width: 680px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  border-radius: 30px;
  width: 100%;
  background: #ffffff;
  height: fit-content;
}

@media (max-width: 768px) {
  .product-detail-container .frame-two {
    padding: 15px;
    border-radius: 20px;
  }
}

@media (max-width: 480px) {
  .product-detail-container .frame-two {
    padding: 12px;
    border-radius: 15px;
  }
}

/* New Tab Design */
.tabs-container {
  display: flex;
  gap: 20px;
  border-bottom: 1px solid #e0e0e0;
  background: #004996;
  border-radius: 14px 14px 0 0;
  padding-top: 10px;
  justify-content: center;
}

.tab-btn {
  position: relative;
  padding: 16px;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  white-space: nowrap;

  @media(max-width: 1300px) {
    /* padding: 14px; */
    font-size: 14px;
  }
}

.tab-btn:hover {
  color: #004996;
  font-weight: 600;
  background: #f9f9f9;
  border-radius: 20px 20px 0 0;

}

.tab-btn.active {
  color: #004996;
  font-weight: 600;
  /* border-bottom: 3px solid #ffffff; */
  background: #f7f7f7;
  border-radius: 20px 20px 0 0;
}

@media (max-width: 768px) {
  .tabs-container {
    gap: 0;
    border-radius: 10px 10px 0 0;
  }

  .tab-btn {
    padding: 14px 24px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .tabs-container {
    flex-direction: column;
    border-radius: 8px 8px 0 0;
    gap: 0;
  }

  .tab-btn {
    padding: 12px 16px;
    font-size: 13px;
    width: 100%;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
    text-align: center;
  }

  .tab-btn.active {
    border-radius: 0;
  }
}

/* Legacy tabs - keeping for backwards compatibility */
.tabs {
  background: #004996;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
  border-radius: 14px;
  position: relative;
  gap: 30px;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .tabs {
    gap: 15px;
    padding-top: 15px;
    border-radius: 10px;
  }
}

@media (max-width: 480px) {
  .tabs {
    gap: 10px;
    padding: 10px;
    flex-direction: column;
    align-items: stretch;
  }
}

/* .tab {
  position: relative;
  padding: 10px 26px;
  background: transparent;
  border: none;
  color: #cfe6ff;
  
  cursor: pointer;
  margin-right: 4px;
  z-index: 1;
} */

.tab:hover {
  color: white;
}

/* Tab bar and active tab polygon clipping style */
.vectorImage {
  position: absolute;
  bottom: 0;
  height: 39px;
  transform: translate(-15%, 1px);
  z-index: 1;

  img {
    width: 100%;
    height: auto;
  }
}

@media (max-width: 768px) {
  .vectorImage {
    height: 35px;
  }
}

@media (max-width: 480px) {
  .vectorImage {
    display: none;
  }
}

.tab {
  color: #fff;
  background: transparent;
  border: none;
  padding: 0 30px;
  height: 100%;
  cursor: pointer;
  position: relative;
  transition: color 0.2s;
  display: flex;
  align-items: center;
  z-index: 2;
}

@media (max-width: 768px) {
  .tab {
    padding: 0 20px;
  }
}

@media (max-width: 480px) {
  .tab {
    width: 100%;
    justify-content: center;
    padding: 12px 15px;
    min-height: 45px;
  }
}

.tab.active {
  color: #004996;
  font-weight: bold;
  z-index: 2;
  height: 60px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  /* Polygon clipping for only top left and top right corners */
  clip-path: polygon(8% 0%, 92% 0%, 100% 20%, 100% 100%, 0% 100%, 0% 20%);
  padding-top: 10px;
}

@media (max-width: 768px) {
  .tab.active {
    height: 50px;
  }
}

@media (max-width: 480px) {
  .tab.active {
    height: auto;
    min-height: 45px;
    border-radius: 8px;
    clip-path: none;
    background: #fff;
  }
}

.catalogue-section .catalogue-files-list .file-info {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 20px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 20PX;

  :hover {
    scale: 1.02;
  }

  .file-icon{
    color: #004996;
    padding: 10px;
    width:50px;
     border-radius:8px;
      box-shadow:0 0 5px rgba(0, 0, 0, 0.35);
      text-align:center;
  }
}

/* TAB CONTENTS */

.tab-content {
  margin-top: 20px;
}
.images-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

@media (max-width: 768px) {
  .images-grid {
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .images-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}

.images-grid img {
  width: 100%;
  /* Clip only top left and bottom right corners */
  clip-path: polygon(
    17% 0%,
    /* top left curve */ 100% 0%,
    100% 80%,
    /* bottom right curve */ 80% 100%,
    0% 100%,
    0% 17%
  );
}

/* Second column: clip only top right and bottom left corners */
.images-grid img:nth-child(2n) {
  clip-path: polygon(
    0% 0%,
    /* top left */ 83% 0%,
    /* cut top-right inward by same 17% */ 100% 17%,
    /* move down on right edge */ 100% 100%,
    /* bottom right */ 20% 100%,
    /* cut bottom-left inward by same 80→20 logic */ 0% 80%
      /* move up on left edge */
  );
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 10px;
}
.videoCard {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;

  h2 {
    width: 100%;
    max-width: 400px;
  }
}

@media (max-width: 768px) {
  .videoCard iframe {
    height: 200px;
  }
}

@media (max-width: 480px) {
  .videoCard {
    gap: 10px;
  }

  .videoCard iframe {
    height: 180px;
  }
}

@media (max-width: 350px) {
  .videoCard {
    flex-direction: column;
    align-items: flex-start;
  }
}
.videoCard iframe {
  border-radius: 14px;
  width: clamp(50px, 40vw, 250px);

  @media (max-width: 350px) {
    width: 100%;
  }
}

.videoCard .contents {
  display: flex;
  gap: 10px;
  flex-direction: column;
}

.btn {
  background: #60a92c;
  color: #ffffff;
  padding: 6px 13px;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  width: max-content;
}

/* Bulk Upload Styles */
.bulk-images-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 15px;
  margin-bottom: 20px;
  padding: 20px;
  width: 100%;
  border-top: 1px solid #f3f4f6;
}

@media (max-width: 768px) {
  .bulk-images-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 10px;
  }
}

@media (max-width: 480px) {
  .bulk-images-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
}

/* @media (max-width: 480px) {
  .bulk-images-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 8px;
  }
} */

.bulk-image-card {
  width: 100%;
  aspect-ratio: 1;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.bulk-image-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  display: block;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.delete-image-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #d32f2f;
  transition: all 0.3s ease;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.delete-image-btn:hover {
  background: #d32f2f;
  color: white;
  transform: scale(1.1);
}

.modal-delete-btn {
  position: absolute;
  /* top: 20px; */
  bottom: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.95);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #d32f2f;
  transition: all 0.3s ease;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.modal-delete-btn:hover {
  background: #d32f2f;
  color: white;
  transform: scale(1.1);
}

.image-preview-modal {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  width: clamp(200px, 80vw, 600px) !important;
  /* max-width: 95vw !important;
  max-height: 95vh !important; */
}

.image-preview-modal .modal-content {
  background: transparent !important;
  padding: 0 !important;
}

.image-modal-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: rgba(0, 0, 0, 0.114); */
  border-radius: 8px;
  /* padding: 20px; */
  width: 100%;
  /* max-width: 90vw;
  max-height: 85vh; */
}

.modal-preview-image {
  width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 4px;
}

.add-new-card {
  width: 100%;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #777;
  font-weight: bold;
  transition: all 0.3s ease;
  border: 2px dashed #ccc;
  border-radius: 10px;
}

.add-new-card:hover {
  color: #004996;
  border-color: #004996;
}

.bulk-video-card {
  width: 100%;
  max-width: 350px;
  aspect-ratio: 16 / 9;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  background: #000;
}

.bulk-video-card.editable-video-card {
  aspect-ratio: auto;
  overflow: visible;
  background: #ffffff;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.editable-video-preview {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 10px;
  overflow: hidden;
  background: #000;
}

.editable-video-preview iframe {
  width: 100%;
  height: 100%;
  display: block;
}

.editable-video-fields {
  width: 100%;
}

.editable-video-fields input,
.editable-video-fields textarea {
  width: 100%;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .bulk-video-card {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .bulk-video-card {
    border-radius: 8px;
  }
}

.add-new-video-card {
  width: 250px;
  height: 150px;
  border-radius: 10px;
  border: 2px dashed #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #777;
  font-weight: bold;
  transition: all 0.3s ease;
}

.add-new-video-card:hover {
  border-color: #004996;
  color: #004996;
  background-color: #f8f9fa;
}


  /* anchor-name: --actionbtn; */


.url-input-container {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  width: 100%;
  max-width: 600px;
  flex-wrap: wrap;
}

@media (max-width: 480px) {
  .url-input-container {
    gap: 8px;
    margin-bottom: 15px;
  }
}

.url-input-container input {
  flex: 1 1;
  min-width: 200px;
  padding: 10px 15px;
  border-radius: 20px;
  border: 1px solid #ccc;
  outline: none;
  box-sizing: border-box;
}

@media (max-width: 480px) {
  .url-input-container input {
    min-width: 100%;
    padding: 8px 12px;
  }
}

/* .url-input-container button {
  padding: 10px 20px;
  border-radius: 20px;
  border: none;
  background: #004996;
  color: white;
  cursor: pointer;
  font-weight: bold;
  transition: background 0.3s;
  white-space: nowrap;
} */

@media (max-width: 480px) {
  .url-input-container button {
    width: 100%;
    padding: 10px 15px;
  }
}

.url-input-container button:hover {
  background: #003366;
}

.body .container {
  margin: 0;
}

.radio {
  margin: 1rem;
  input[type="radio"] {
    position: absolute;
    opacity: 0;
    + .radio-label {
      &:before {
        content: "";
        background: rgb(154, 154, 154);
        border-radius: 100%;
        border: 1px solid darken(rgb(162, 162, 169), 25%);
        display: inline-block;
        width: 1em;
        height: 1em;
        position: relative;
        /* top: -0.2em;/ */
        margin-right: 1em;
        vertical-align: top;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
      }
    }
    &:checked {
      + .radio-label {
        &:before {
          background-color: #ffffff;
          box-shadow: inset 0 0 0 4px #004996;
        }
      }
    }
    &:focus {
      + .radio-label {
        &:before {
          outline: none;
          border-color: 1px solid red;
        }
      }
    }
    &:disabled {
      + .radio-label {
        &:before {
          box-shadow: inset 0 0 0 4px blue;
          border-color: darken(blue, 25%);
          background: darken(rgb(162, 162, 169), 25%);
        }
      }
    }
    + .radio-label {
      &:empty {
        &:before {
          margin-right: 0;
        }
      }
    }
  }
}

.text-inputs {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
  width: 100%;
}

.text-inputs > div {
  width: 100%;
}

.field-error {
  margin: 6px 0 0;
  color: #d32f2f;
  font-size: 13px;
  line-height: 1.35;
}

.image-upload-section {
  flex-shrink: 0;

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    width: 100%;
  }
}

@media (max-width: 768px) {
  .form-header {
    flex-direction: column;
    align-items: stretch;
  }

  .text-inputs {
    width: 100%;
  }
}
.name {
  margin-top: 20px;
}
.formContact {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.body .form-headerr {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.body .form-headerr .image-upload-section {
  display: flex;
  grid-column: 1 / -1;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
}

.body .form-headerr .image-upload-section h4{
  font-weight: 500;
}

.createNew {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}
.createNew select{
 padding: 8px 30px;
}
select {
  /* styling */
  background-color: white;
  border:none;
  border-radius: 12px;
  display: inline-block;
  font: inherit;
  padding: 1em;

  /* reset */

  margin: 0;
  box-sizing: border-box;
  appearance: none;
}

/* arrows */

select.classic {
  background-image: linear-gradient(45deg, transparent 50%, #004996 50%),
    linear-gradient(135deg, #004996 50%, transparent 50%),
    linear-gradient(to right, #ffffff8c, #004996);
  background-position: calc(100% - 20px) calc(1em + 2px),
    calc(100% - 15px) calc(1em + 2px), 100% 0;
  background-size: 5px 5px, 5px 5px, 2.5em 2.5em;
  background-repeat: no-repeat;
  font-weight: 500;
}

select.classic:focus {
  background-image: linear-gradient(45deg, white 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, white 50%),
    linear-gradient(to right, #ffffff8c, #004996);
  background-position: calc(100% - 15px) 1em, calc(100% - 20px) 1em, 100% 0;
  background-size: 5px 5px, 5px 5px, 2.5em 2.5em;
  background-repeat: no-repeat;
  border-color: #004996;
  outline: 0;
}
.mediaUploads .card:hover {
  /* transform: translateY(-6px); */
  transition: 0.3s ease;
  scale: 1.02;
}

.mediaUploads .images-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: 1074px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 767px) {
    grid-template-columns: repeat(1, 1fr);
  }
}
.mediaUploads .video-grid,
.mediaUploads .catalogue-section {
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: 1074px) {
    grid-template-columns: repeat(1, 1fr);
  }
  @media (max-width: 767px) {
    grid-template-columns: repeat(1, 1fr);
  }
}
.mediaUploads .videoCard {
  justify-content: flex-start;
}
.mediaUploads .mainData {
  display: flex;
  gap: 20px;
  margin: 20px 0;
  background: #e0dfdf73;
  padding: 20px;
  border-radius: 12px;

  @media (max-width: 767px) {
    flex-direction: column;
  }
  @media (max-width: 450px) {
    flex-direction: column;
    align-items: center;
  }
}

.mediaUploads .mainData .contents {
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;

  p {
    width: 100%;
  }
}
.mediaUploads .mainData img {
  width: clamp(240px, 15vw, 400px);
  border-radius: 12px;
}

.mediaUploads .frame-two {
  background: #e0dfdf73;
  padding: 20px;
  border-radius: 12px;
}
/* 
.mediaUpload .body {
  display: unset;
  background: rgba(234, 229, 229, 0.172);
} */

.mediaUpload .select-container {
  margin-top: 10px;
}

.mediaUpload .selectIndustry {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  width: 100%;
  margin-top: 10px;
  align-items: end;

  @media(max-width: 992px) {
    grid-template-columns: 1fr;
  }
}

.mediaUpload .selecttype{
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  width: 100%;
  margin-top: 10px;
  text-align: left;
}

.mediaUpload .form-header{
  display: grid;
   grid-template-columns: 1fr 1fr;
   gap: 20px;

   @media(max-width: 992px) {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/createproduct.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB,EAAE,kDAAkD;AACvE;;AAEA;EACE,SAAS;EACT,WAAW;EACX,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;IACT,UAAU;EACZ;AACF;;AAEA,2BAA2B;;AAE3B;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;;EAEX;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,SAAO;;EAEP;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;;EAEtC;IACE,WAAW;EACb;AACF;AACA,yBAAyB;;AAEzB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;;EAEnB;IACE,4BAA4B;IAC5B,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;EACnB,WAAW;;EAEX;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;AACA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,SAAS;IACT,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,SAAS;IACT,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,aAAa;;EAEb;IACE,sBAAsB;EACxB,cAAc;;EAEd;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;;EAEnB;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;AACF;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,SAAS;EACT,8BAA8B;;EAE9B;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;;EAEhB;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB;IACE,cAAc;IACd,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;;EAEjB;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,UAAU;IACV;MACE,aAAa;MACb;QACE,qBAAqB;QACrB,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;QACnB,mBAAmB;QACnB,6BAA6B;QAC7B,+CAA+C;QAC/C,eAAe;QACf,mBAAmB;QACnB,gCAAgC;QAChC;UACE,mBAAmB;UACnB,qBAAqB;QACvB;QACA;UACE,gBAAgB;UAChB,0BAA0B;UAC1B,cAAc;UACd,kBAAkB;UAClB,SAAS;UACT,OAAO;UACP,QAAQ;UACR,kBAAkB;UAClB,YAAY;QACd;MACF;IACF;EACF;EACA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB,8CAA8C;;IAE9C;MACE,YAAY;MACZ,aAAa;MACb,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,mBAAmB;IACrB;IACA;MACE,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,sBAAsB;MACtB,4BAA4B;MAC5B,2BAA2B;IAC7B;EACF;AACF;;AAEA,KAAK;;AAEL;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;EACtC,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;;;;;;GAMG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;EACtC,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;;AAE5B;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,sEAAsE;EACtE,gCAAgC;EAChC,cAAc;;EAEd;IACE,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,qCAAqC;EACvC;;EAEA;IACE,WAAW;IACX,SAAS;IACT,aAAa;IACb,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,SAAS;EACX;AACF;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gDAAgD;EAChD,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;;EAEnB;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;;AAE9B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE;IACE,MAAM;IACN,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,MAAM;EACR;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,sDAAsD;AACtD;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,SAAS;IACT,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,+BAA+B;EAC/B,UAAU;;EAEV;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,yCAAyC;EACzC,6DAA6D;EAC7D,uEAAuE;EACvE,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,aAAa;IACb,UAAU;KACT,iBAAiB;MAChB,sCAAsC;MACtC,iBAAiB;EACrB;AACF;;AAEA,iBAAiB;;AAEjB;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,WAAW;EACX,gDAAgD;EAChD;;;;;;;GAOC;AACH;;AAEA,+DAA+D;AAC/D;EACE;;;;;;;;GAQC;AACH;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;;EAET;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;AACA;EACE,mBAAmB;EACnB,+BAA+B;;EAE/B;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE;IACE,4DAA4D;IAC5D,SAAS;EACX;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,QAAQ;EACV;AACF;;AAEA;;;;;GAKG;;AAEH;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,qBAAqB;EACrB,2CAA2C;EAC3C;gCAC8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX;qBACmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;;EAGE,8BAA8B;;;AAGhC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,QAAQ;IACR,mBAAmB;EACrB;AACF;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ;IACE,kBAAkB;IAClB,UAAU;IACV;MACE;QACE,WAAW;QACX,8BAA8B;QAC9B,mBAAmB;QACnB,iDAAiD;QACjD,qBAAqB;QACrB,UAAU;QACV,WAAW;QACX,kBAAkB;QAClB,kBAAkB;QAClB,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;QACf,kBAAkB;QAClB,0BAA0B;MAC5B;IACF;IACA;MACE;QACE;UACE,yBAAyB;UACzB,mCAAmC;QACrC;MACF;IACF;IACA;MACE;QACE;UACE,aAAa;UACb,2BAA2B;QAC7B;MACF;IACF;IACA;MACE;QACE;UACE,gCAAgC;UAChC,+BAA+B;UAC/B,2CAA2C;QAC7C;MACF;IACF;IACA;MACE;QACE;UACE,eAAe;QACjB;MACF;IACF;EACF;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;;EAEd;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;;EAET;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,SAAS;;EAET;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;CACC,iBAAiB;AAClB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,YAAY;;EAEZ,UAAU;;EAEV,SAAS;EAGT,sBAAsB;EAGtB,gBAAgB;AAClB;;AAEA,WAAW;;AAEX;EACE;;iDAE+C;EAC/C;6CAC2C;EAC3C,8CAA8C;EAC9C,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;;iDAE+C;EAC/C,yEAAyE;EACzE,8CAA8C;EAC9C,4BAA4B;EAC5B,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;;EAErC;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;AACF;AACA;;EAEE,aAAa;EACb,qCAAqC;;EAErC;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;;EAEnB;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;;EAEvB;IACE,WAAW;EACb;AACF;AACA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;AACA;;;;GAIG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;;EAEhB;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;GACZ,8BAA8B;GAC9B,SAAS;;GAET;IACC,0BAA0B;EAC5B;AACF","sourcesContent":["/* Clamp card description to 4 lines with ellipsis */\n.card__text--clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n  min-height: 5.2em; /* Ensures card height is consistent for 4 lines */\n}\n\n.body {\n  gap: 20px;\n  width: 100%;\n  padding: 20px;\n  background: rgba(234, 229, 229, 0.172);\n  border-radius: 12px;\n  margin-top: 20px;\n}\n\n@media (max-width: 1024px) {\n  .body {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 768px) {\n  .body {\n    gap: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .body {\n    gap: 10px;\n    padding: 0;\n  }\n}\n\n/* Input Fields Container */\n\n.inputFields {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n@media (max-width: 1024px) {\n  .inputFields {\n    width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .inputFields {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .inputFields {\n    width: 100%;\n  }\n}\n\n/* select options  */\n.select-container {\n  text-align: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n@media (max-width: 768px) {\n  .select-container {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .select-container {\n    width: 100%;\n  }\n}\n\n.form {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 15px;\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  .form {\n    gap: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .form {\n    gap: 10px;\n  }\n}\n\n.form select {\n  width: 100%;\n  padding: 15px;\n  padding-left: 10px;\n  background-color: #fff;\n  border-radius: 10px;\n  border: none;\n  outline: none;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n@media (max-width: 768px) {\n  .form select {\n    padding: 12px 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .form select {\n    padding: 10px 8px;\n  }\n}\n\n.modal-tags-container {\n  width: 100%;\n}\n\n.modal-tags-container .addbtn {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n\n  @media (max-width: 480px) {\n    flex-direction: column;\n  }\n}\n\n.modal-tags-container .addbtn input {\n  flex: 1;\n\n  @media (max-width: 480px) {\n    width: 100%;\n  }\n}\n\n.modal-tags-container .addbtn button {\n  padding: 10px 20px;\n  border-radius: 30px;\n  border: none;\n  background: #004996;\n  color: white;\n  cursor: pointer;\n  font-weight: 500;\n  white-space: nowrap;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n\n  @media (max-width: 480px) {\n    width: 100%;\n  }\n}\n/* -------------------- */\n\n.form-header {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n\n  @media (max-width: 768px) {\n    /* flex-direction: column; */\n    align-items: stretch;\n    gap: 15px;\n  }\n\n  @media (max-width: 360px) {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n.videoContainer {\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n  border-radius: 30px;\n  width: 100%;\n  padding: 20px;\n  height: fit-content;\n  margin-top: 10px;\n  box-sizing: border-box;\n}\n\n@media (max-width: 768px) {\n  .videoContainer {\n    padding: 15px;\n    border-radius: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .videoContainer {\n    padding: 12px;\n    border-radius: 15px;\n  }\n}\n\n.videoContainer h1 {\n  text-align: left;\n}\n\n.videoContainer .bulk-video-grid {\n  justify-content: flex-start;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 15px;\n  margin-bottom: 20px;\n  width: 100%;\n\n  @media (max-width: 768px) {\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 12px;\n  }\n\n  @media (max-width: 480px) {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n}\n.uploadSection {\n  display: flex;\n  /* gap: 20px; */\n  flex-wrap: wrap;\n  margin-top: 20px;\n  align-items: flex-start;\n  justify-content: center;\n  width: 100%;\n}\n\n@media (max-width: 1024px) {\n  .uploadSection {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .uploadSection {\n    gap: 15px;\n    margin-top: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .uploadSection {\n    gap: 10px;\n    margin-top: 10px;\n  }\n}\n.fileUpload {\n  background: #ffffff;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  border-radius: 30px;\n  width: 100%;\n  /* max-width: 800px; */\n  padding: 0;\n  height: fit-content;\n  margin-top: 10px;\n  position: relative;\n  box-sizing: border-box;\n}\n.radioBtns{\n  display: flex;\n\n  @media (max-width: 370px) {\n    flex-direction: column;\n  display: block;\n\n  }\n}\n@media (max-width: 768px) {\n  .fileUpload {\n    border-radius: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .fileUpload {\n    border-radius: 8px;\n    margin-top: 5px;\n  }\n}\n.upArea {\n  display: flex;\n  align-items: center;\n\n  @media (max-width: 1200px) {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n}\n.fileUpload .upload-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 25px 15px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.fileUpload .upload-header h1 {\n  margin: 0;\n  color: #1a1a1a;\n}\n\n.fileUpload .close-btn {\n  background: none;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.fileUpload .close-btn:hover {\n  color: #1a1a1a;\n}\n\n.fileUpload .file-type-selector {\n  padding: 15px 25px;\n}\n\n.fileUpload .file-type-selector label {\n  display: block;\n  color: #9ca3af;\n  margin-bottom: 10px;\n}\n\n.fileUpload .radio-group {\n  display: flex;\n  gap: 20px;\n}\n\n.fileUpload .radio-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  margin: 0;\n}\n\n.fileUpload .radio-option input[type=\"radio\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  margin: 0;\n  accent-color: #004996;\n}\n\n.fileUpload .radio-option span {\n  color: #1a1a1a;\n}\n\n.fileUpload .upload-area {\n  border: 2px dashed #d1d5db;\n  border-radius: 8px;\n  padding: 10px;\n  text-align: center;\n  background: #ffffff;\n  margin: 15px 25px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.fileUpload .upload-area:hover {\n  border-color: #004996;\n  background: #fafafa;\n}\n\n.fileUpload .upload-area::after {\n  content: \"\";\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: flex;\n  gap: 5px;\n}\n\n.fileUpload .upload-area .plus-icon {\n  color: #1a1a1a;\n  margin-bottom: 8px;\n  font-weight: 300;\n}\n\n.fileUpload .upload-area p {\n  color: #1a1a1a;\n  margin: 5px 0;\n}\n\n.fileUpload .upload-area .file-info {\n  color: #9ca3af;\n}\n\n.fileUpload .file-list {\n  padding: 0 25px;\n  margin: 20px 0;\n  max-height: 280px;\n  overflow-y: scroll;\n  width: calc(100% - 50px);\n  display: grid;\n  gap: 10px;\n  grid-template-columns: 1fr 1fr;\n\n  @media (max-width: 1200px) {\n    width: 100%;\n  }\n  @media (max-width: 767px) {\n    width: 100%;\n    grid-template-columns: 1fr;\n  }\n}\n\n.fileUpload .file-item {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 12px 15px;\n  background: #fafafa;\n  border-radius: 8px;\n  margin-bottom: 10px;\n  border: 1px solid #f0f0f0;\n}\n\n.fileUpload .file-item .file-info-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  flex: 1;\n}\n\n.fileUpload .file-item .file-icon {\n  margin-top: 2px;\n}\n\n.fileUpload .file-item .file-details {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  flex: 1;\n}\n\n.fileUpload .file-item .file-name {\n  color: #1a1a1a;\n  font-weight: 500;\n  margin: 0;\n}\n\n.fileUpload .file-item .file-meta {\n  display: flex;\n  gap: 8px;\n  color: #9ca3af;\n}\n\n.fileUpload .file-item .file-size {\n  color: #9ca3af;\n}\n\n.fileUpload .file-item .file-progress {\n  color: #1a1a1a;\n  font-weight: 500;\n}\n\n.fileUpload .file-item .file-time {\n  color: #9ca3af;\n}\n\n.fileUpload .file-item .file-status-text {\n  color: #10b981;\n  font-weight: 500;\n}\n\n.fileUpload .file-item .file-status-text.error {\n  color: #ef4444;\n}\n\n.fileUpload .progress-bar {\n  width: 100%;\n  height: 4px;\n  background: #e5e7eb;\n  border-radius: 2px;\n  overflow: hidden;\n  margin-top: 3px;\n}\n\n.fileUpload .progress-fill {\n  height: 100%;\n  background: #18a103;\n  transition: width 0.3s ease;\n}\n\n.fileUpload .file-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.fileUpload .retry-btn {\n  background: none;\n  border: none;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n}\n\n.fileUpload .retry-btn:hover {\n  color: #1a1a1a;\n}\n\n.fileUpload .delete-btn {\n  background: none;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n}\n\n.fileUpload .delete-btn:hover {\n  color: #ef4444;\n}\n\n.button-group {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  padding: 20px 25px;\n  border-top: 1px solid #f3f4f6;\n  margin-top: 10px;\n\n  @media(max-width: 600px) {\n    flex-direction: column;\n  }\n}\n\n.button-group .cancel-btn {\n  background: #ffffff;\n  color: #6b7280;\n  padding: 10px 30px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-weight: 500;\n}\n\n.fileUpload .button-group .cancel-btn:hover {\n  background: #f9fafb;\n  border-color: #d1d5db;\n}\n\n.fileUpload .button-group .save-btn {\n  background: #004996;\n  color: #ffffff;\n  padding: 10px 40px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.fileUpload .button-group .save-btn:hover {\n  background: #004996;\n}\n.UploadImages {\n  background: #ffffff;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n  border-radius: 30px;\n  width: 100%;\n  padding: 20px;\n  height: fit-content;\n  box-sizing: border-box;\n}\n\n@media (max-width: 768px) {\n  .UploadImages {\n    padding: 15px;\n    border-radius: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .UploadImages {\n    padding: 12px;\n    border-radius: 15px;\n  }\n}\n\n.bulkThumbnail h1 {\n  margin-bottom: 15px;\n}\n\n.bulkUpload {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n/* upload thumbnail image css */\n.container {\n  max-width: 960px;\n  margin: 30px auto;\n  /* padding: 20px; */\n  text-align: left;\n}\n\nh1 {\n  text-align: left;\n  margin: 20px 0 20px;\n  small {\n    display: block;\n    padding-top: 8px;\n    color: gray;\n  }\n}\n\n.avatar-upload {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  margin: 50px auto;\n\n  @media (max-width: 768px) {\n    width: 100px;\n    height: 100px;\n    margin: 20px auto;\n  }\n\n  @media (max-width: 480px) {\n    width: 90px;\n    height: 90px;\n    margin: 15px auto;\n  }\n  .avatar-edit {\n    position: absolute;\n    right: -10px;\n    z-index: 1;\n    top: -10px;\n    input {\n      display: none;\n      + label {\n        display: inline-block;\n        width: 34px;\n        height: 34px;\n        margin-bottom: 0;\n        border-radius: 100%;\n        background: #ffffff;\n        border: 1px solid transparent;\n        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n        cursor: pointer;\n        font-weight: normal;\n        transition: all 0.2s ease-in-out;\n        &:hover {\n          background: #f1f1f1;\n          border-color: #d6d6d6;\n        }\n        &:after {\n          content: \"\\f040\";\n          font-family: \"FontAwesome\";\n          color: #757575;\n          position: absolute;\n          top: 10px;\n          left: 0;\n          right: 0;\n          text-align: center;\n          margin: auto;\n        }\n      }\n    }\n  }\n  .avatar-preview {\n    width: 120px;\n    height: 120px;\n    position: relative;\n    border: 1px dashed #004996;\n    border-radius: 30px;\n    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n\n    @media (max-width: 768px) {\n      width: 100px;\n      height: 100px;\n      border-radius: 20px;\n    }\n\n    @media (max-width: 480px) {\n      width: 90px;\n      height: 90px;\n      border-radius: 15px;\n    }\n    > div {\n      width: 100%;\n      height: 100%;\n      border-radius: 30px;\n      background-size: cover;\n      background-repeat: no-repeat;\n      background-position: center;\n    }\n  }\n}\n\n/*  */\n\n.body form {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.body form input {\n  /* height: 50px; */\n  border-radius: 10px;\n  border: none;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n  padding: 15px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n@media (max-width: 768px) {\n  .body form input {\n    height: 45px;\n    padding: 15px;\n    border-radius: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .body form input {\n    height: 42px;\n    padding: 12px;\n    border-radius: 15px;\n  }\n}\n\n/* @media (max-width: 480px) {\n  .body form input {\n    height: 42px;\n    padding: 12px;\n    border-radius: 20px;\n  }\n} */\n\n.body form label {\n  margin-top: 10px;\n}\n\n.body form .label {\n  margin-top: 20px;\n}\n\n.body form textarea {\n  border-radius: 20px;\n  border: none;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  width: 100%;\n  /* max-width: 800px; */\n  resize: vertical;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n@media (max-width: 1024px) {\n  .body form textarea {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .body form textarea {\n    padding: 15px;\n    border-radius: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .body form textarea {\n    padding: 12px;\n    border-radius: 12px;\n  }\n}\n\n.body form .description {\n  margin-top: 20px;\n}\n\n/* PRODUCT DETAIL PAGE CSS */\n\n.product-detail-container {\n  display: grid;\n  gap: 30px;\n  margin: 20px;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 320px), 1fr));\n  width: clamp(300px, 90%, 1520px);\n  margin: 0 auto;\n\n  @media (max-width: 1024px) {\n    justify-items: center;\n    margin-top: 20px;\n    width: 95%;\n    gap: 20px;\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n    margin: 0;\n    padding: 10px;\n    gap: 15px;\n  }\n\n  @media (max-width: 480px) {\n    padding: 5px;\n    gap: 10px;\n  }\n}\n\n.product-detail-container .frame-one {\n  max-width: 680px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  border-radius: 30px;\n  padding: 20px;\n  width: 100%;\n  background: #ffffff;\n  height: fit-content;\n}\n\n@media (max-width: 768px) {\n  .product-detail-container .frame-one {\n    padding: 15px;\n    border-radius: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .product-detail-container .frame-one {\n    padding: 12px;\n    border-radius: 15px;\n  }\n}\n\n.product-detail-container .frame-one img {\n  margin: 0 auto;\n  width: 100%;\n  /* Clip only top right and bottom left corners */\n  clip-path: polygon(0% 0%, 80% 0%, 100% 17%, 100% 100%, 17% 100%, 0% 80%);\n}\n\n.product-detail-container .frame-one .content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 40px;\n}\n\n.product-detail-container .frame-one .description {\n  margin-top: 20px;\n}\n\np {\n  color: #000000;\n}\n\n.product-detail-container .frame-two {\n  max-width: 680px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  border-radius: 30px;\n  width: 100%;\n  background: #ffffff;\n  height: fit-content;\n}\n\n@media (max-width: 768px) {\n  .product-detail-container .frame-two {\n    padding: 15px;\n    border-radius: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .product-detail-container .frame-two {\n    padding: 12px;\n    border-radius: 15px;\n  }\n}\n\n/* New Tab Design */\n.tabs-container {\n  display: flex;\n  gap: 20px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #004996;\n  border-radius: 14px 14px 0 0;\n  padding-top: 10px;\n  justify-content: center;\n}\n\n.tab-btn {\n  position: relative;\n  padding: 16px;\n  background: transparent;\n  border: none;\n  color: #ffffff;\n  font-size: 15px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-bottom: 3px solid transparent;\n  white-space: nowrap;\n\n  @media(max-width: 1300px) {\n    /* padding: 14px; */\n    font-size: 14px;\n  }\n}\n\n.tab-btn:hover {\n  color: #004996;\n  font-weight: 600;\n  background: #f9f9f9;\n  border-radius: 20px 20px 0 0;\n\n}\n\n.tab-btn.active {\n  color: #004996;\n  font-weight: 600;\n  /* border-bottom: 3px solid #ffffff; */\n  background: #f7f7f7;\n  border-radius: 20px 20px 0 0;\n}\n\n@media (max-width: 768px) {\n  .tabs-container {\n    gap: 0;\n    border-radius: 10px 10px 0 0;\n  }\n\n  .tab-btn {\n    padding: 14px 24px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .tabs-container {\n    flex-direction: column;\n    border-radius: 8px 8px 0 0;\n    gap: 0;\n  }\n\n  .tab-btn {\n    padding: 12px 16px;\n    font-size: 13px;\n    width: 100%;\n    text-align: left;\n    border-bottom: 1px solid #e0e0e0;\n    text-align: center;\n  }\n\n  .tab-btn.active {\n    border-radius: 0;\n  }\n}\n\n/* Legacy tabs - keeping for backwards compatibility */\n.tabs {\n  background: #004996;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 20px;\n  border-radius: 14px;\n  position: relative;\n  gap: 30px;\n  flex-wrap: wrap;\n}\n\n@media (max-width: 768px) {\n  .tabs {\n    gap: 15px;\n    padding-top: 15px;\n    border-radius: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .tabs {\n    gap: 10px;\n    padding: 10px;\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n/* .tab {\n  position: relative;\n  padding: 10px 26px;\n  background: transparent;\n  border: none;\n  color: #cfe6ff;\n  \n  cursor: pointer;\n  margin-right: 4px;\n  z-index: 1;\n} */\n\n.tab:hover {\n  color: white;\n}\n\n/* Tab bar and active tab polygon clipping style */\n.vectorImage {\n  position: absolute;\n  bottom: 0;\n  height: 39px;\n  transform: translate(-15%, 1px);\n  z-index: 1;\n\n  img {\n    width: 100%;\n    height: auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .vectorImage {\n    height: 35px;\n  }\n}\n\n@media (max-width: 480px) {\n  .vectorImage {\n    display: none;\n  }\n}\n\n.tab {\n  color: #fff;\n  background: transparent;\n  border: none;\n  padding: 0 30px;\n  height: 100%;\n  cursor: pointer;\n  position: relative;\n  transition: color 0.2s;\n  display: flex;\n  align-items: center;\n  z-index: 2;\n}\n\n@media (max-width: 768px) {\n  .tab {\n    padding: 0 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .tab {\n    width: 100%;\n    justify-content: center;\n    padding: 12px 15px;\n    min-height: 45px;\n  }\n}\n\n.tab.active {\n  color: #004996;\n  font-weight: bold;\n  z-index: 2;\n  height: 60px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  /* Polygon clipping for only top left and top right corners */\n  clip-path: polygon(8% 0%, 92% 0%, 100% 20%, 100% 100%, 0% 100%, 0% 20%);\n  padding-top: 10px;\n}\n\n@media (max-width: 768px) {\n  .tab.active {\n    height: 50px;\n  }\n}\n\n@media (max-width: 480px) {\n  .tab.active {\n    height: auto;\n    min-height: 45px;\n    border-radius: 8px;\n    clip-path: none;\n    background: #fff;\n  }\n}\n\n.catalogue-section .catalogue-files-list .file-info {\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n  border-radius: 12px;\n  padding: 20px;\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  gap: 20PX;\n\n  :hover {\n    scale: 1.02;\n  }\n\n  .file-icon{\n    color: #004996;\n    padding: 10px;\n    width:50px;\n     border-radius:8px;\n      box-shadow:0 0 5px rgba(0, 0, 0, 0.35);\n      text-align:center;\n  }\n}\n\n/* TAB CONTENTS */\n\n.tab-content {\n  margin-top: 20px;\n}\n.images-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n@media (max-width: 768px) {\n  .images-grid {\n    gap: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .images-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n}\n\n.images-grid img {\n  width: 100%;\n  /* Clip only top left and bottom right corners */\n  clip-path: polygon(\n    17% 0%,\n    /* top left curve */ 100% 0%,\n    100% 80%,\n    /* bottom right curve */ 80% 100%,\n    0% 100%,\n    0% 17%\n  );\n}\n\n/* Second column: clip only top right and bottom left corners */\n.images-grid img:nth-child(2n) {\n  clip-path: polygon(\n    0% 0%,\n    /* top left */ 83% 0%,\n    /* cut top-right inward by same 17% */ 100% 17%,\n    /* move down on right edge */ 100% 100%,\n    /* bottom right */ 20% 100%,\n    /* cut bottom-left inward by same 80→20 logic */ 0% 80%\n      /* move up on left edge */\n  );\n}\n\n.video-grid {\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  gap: 10px;\n}\n.videoCard {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n\n  h2 {\n    width: 100%;\n    max-width: 400px;\n  }\n}\n\n@media (max-width: 768px) {\n  .videoCard iframe {\n    height: 200px;\n  }\n}\n\n@media (max-width: 480px) {\n  .videoCard {\n    gap: 10px;\n  }\n\n  .videoCard iframe {\n    height: 180px;\n  }\n}\n\n@media (max-width: 350px) {\n  .videoCard {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n.videoCard iframe {\n  border-radius: 14px;\n  width: clamp(50px, 40vw, 250px);\n\n  @media (max-width: 350px) {\n    width: 100%;\n  }\n}\n\n.videoCard .contents {\n  display: flex;\n  gap: 10px;\n  flex-direction: column;\n}\n\n.btn {\n  background: #60a92c;\n  color: #ffffff;\n  padding: 6px 13px;\n  border-radius: 14px;\n  border: none;\n  cursor: pointer;\n  width: max-content;\n}\n\n/* Bulk Upload Styles */\n.bulk-images-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 15px;\n  margin-bottom: 20px;\n  padding: 20px;\n  width: 100%;\n  border-top: 1px solid #f3f4f6;\n}\n\n@media (max-width: 768px) {\n  .bulk-images-grid {\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n    gap: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .bulk-images-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 8px;\n  }\n}\n\n/* @media (max-width: 480px) {\n  .bulk-images-grid {\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n    gap: 8px;\n  }\n} */\n\n.bulk-image-card {\n  width: 100%;\n  aspect-ratio: 1;\n  border-radius: 10px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n\n.bulk-image-card img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n  display: block;\n  cursor: pointer;\n  position: relative;\n  z-index: 1;\n}\n\n.delete-image-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #d32f2f;\n  transition: all 0.3s ease;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.delete-image-btn:hover {\n  background: #d32f2f;\n  color: white;\n  transform: scale(1.1);\n}\n\n.modal-delete-btn {\n  position: absolute;\n  /* top: 20px; */\n  bottom: 20px;\n  right: 20px;\n  background: rgba(255, 255, 255, 0.95);\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #d32f2f;\n  transition: all 0.3s ease;\n  z-index: 1000;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.modal-delete-btn:hover {\n  background: #d32f2f;\n  color: white;\n  transform: scale(1.1);\n}\n\n.image-preview-modal {\n  background: transparent !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n  width: clamp(200px, 80vw, 600px) !important;\n  /* max-width: 95vw !important;\n  max-height: 95vh !important; */\n}\n\n.image-preview-modal .modal-content {\n  background: transparent !important;\n  padding: 0 !important;\n}\n\n.image-modal-wrapper {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* background: rgba(0, 0, 0, 0.114); */\n  border-radius: 8px;\n  /* padding: 20px; */\n  width: 100%;\n  /* max-width: 90vw;\n  max-height: 85vh; */\n}\n\n.modal-preview-image {\n  width: 100%;\n  max-height: 80vh;\n  object-fit: contain;\n  border-radius: 4px;\n}\n\n.add-new-card {\n  width: 100%;\n  aspect-ratio: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #777;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  border: 2px dashed #ccc;\n  border-radius: 10px;\n}\n\n.add-new-card:hover {\n  color: #004996;\n  border-color: #004996;\n}\n\n.bulk-video-card {\n  width: 100%;\n  max-width: 350px;\n  aspect-ratio: 16 / 9;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  background: #000;\n}\n\n.bulk-video-card.editable-video-card {\n  aspect-ratio: auto;\n  overflow: visible;\n  background: #ffffff;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.editable-video-preview {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #000;\n}\n\n.editable-video-preview iframe {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.editable-video-fields {\n  width: 100%;\n}\n\n.editable-video-fields input,\n.editable-video-fields textarea {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n@media (max-width: 768px) {\n  .bulk-video-card {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .bulk-video-card {\n    border-radius: 8px;\n  }\n}\n\n.add-new-video-card {\n  width: 250px;\n  height: 150px;\n  border-radius: 10px;\n  border: 2px dashed #ccc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #777;\n  font-weight: bold;\n  transition: all 0.3s ease;\n}\n\n.add-new-video-card:hover {\n  border-color: #004996;\n  color: #004996;\n  background-color: #f8f9fa;\n}\n\n\n  /* anchor-name: --actionbtn; */\n\n\n.url-input-container {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  width: 100%;\n  max-width: 600px;\n  flex-wrap: wrap;\n}\n\n@media (max-width: 480px) {\n  .url-input-container {\n    gap: 8px;\n    margin-bottom: 15px;\n  }\n}\n\n.url-input-container input {\n  flex: 1;\n  min-width: 200px;\n  padding: 10px 15px;\n  border-radius: 20px;\n  border: 1px solid #ccc;\n  outline: none;\n  box-sizing: border-box;\n}\n\n@media (max-width: 480px) {\n  .url-input-container input {\n    min-width: 100%;\n    padding: 8px 12px;\n  }\n}\n\n/* .url-input-container button {\n  padding: 10px 20px;\n  border-radius: 20px;\n  border: none;\n  background: #004996;\n  color: white;\n  cursor: pointer;\n  font-weight: bold;\n  transition: background 0.3s;\n  white-space: nowrap;\n} */\n\n@media (max-width: 480px) {\n  .url-input-container button {\n    width: 100%;\n    padding: 10px 15px;\n  }\n}\n\n.url-input-container button:hover {\n  background: #003366;\n}\n\n.body .container {\n  margin: 0;\n}\n\n.radio {\n  margin: 1rem;\n  input[type=\"radio\"] {\n    position: absolute;\n    opacity: 0;\n    + .radio-label {\n      &:before {\n        content: \"\";\n        background: rgb(154, 154, 154);\n        border-radius: 100%;\n        border: 1px solid darken(rgb(162, 162, 169), 25%);\n        display: inline-block;\n        width: 1em;\n        height: 1em;\n        position: relative;\n        /* top: -0.2em;/ */\n        margin-right: 1em;\n        vertical-align: top;\n        cursor: pointer;\n        text-align: center;\n        transition: all 250ms ease;\n      }\n    }\n    &:checked {\n      + .radio-label {\n        &:before {\n          background-color: #ffffff;\n          box-shadow: inset 0 0 0 4px #004996;\n        }\n      }\n    }\n    &:focus {\n      + .radio-label {\n        &:before {\n          outline: none;\n          border-color: 1px solid red;\n        }\n      }\n    }\n    &:disabled {\n      + .radio-label {\n        &:before {\n          box-shadow: inset 0 0 0 4px blue;\n          border-color: darken(blue, 25%);\n          background: darken(rgb(162, 162, 169), 25%);\n        }\n      }\n    }\n    + .radio-label {\n      &:empty {\n        &:before {\n          margin-right: 0;\n        }\n      }\n    }\n  }\n}\n\n.text-inputs {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-width: 0;\n  width: 100%;\n}\n\n.text-inputs > div {\n  width: 100%;\n}\n\n.field-error {\n  margin: 6px 0 0;\n  color: #d32f2f;\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n.image-upload-section {\n  flex-shrink: 0;\n\n  @media (max-width: 768px) {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .form-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .text-inputs {\n    width: 100%;\n  }\n}\n.name {\n  margin-top: 20px;\n}\n.formContact {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.body .form-headerr {\n  margin-top: 10px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.body .form-headerr .image-upload-section {\n  display: flex;\n  grid-column: 1 / -1;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.body .form-headerr .image-upload-section h4{\n  font-weight: 500;\n}\n\n.createNew {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n.createNew select{\n padding: 8px 30px;\n}\nselect {\n  /* styling */\n  background-color: white;\n  border:none;\n  border-radius: 12px;\n  display: inline-block;\n  font: inherit;\n  padding: 1em;\n\n  /* reset */\n\n  margin: 0;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n/* arrows */\n\nselect.classic {\n  background-image: linear-gradient(45deg, transparent 50%, #004996 50%),\n    linear-gradient(135deg, #004996 50%, transparent 50%),\n    linear-gradient(to right, #ffffff8c, #004996);\n  background-position: calc(100% - 20px) calc(1em + 2px),\n    calc(100% - 15px) calc(1em + 2px), 100% 0;\n  background-size: 5px 5px, 5px 5px, 2.5em 2.5em;\n  background-repeat: no-repeat;\n  font-weight: 500;\n}\n\nselect.classic:focus {\n  background-image: linear-gradient(45deg, white 50%, transparent 50%),\n    linear-gradient(135deg, transparent 50%, white 50%),\n    linear-gradient(to right, #ffffff8c, #004996);\n  background-position: calc(100% - 15px) 1em, calc(100% - 20px) 1em, 100% 0;\n  background-size: 5px 5px, 5px 5px, 2.5em 2.5em;\n  background-repeat: no-repeat;\n  border-color: #004996;\n  outline: 0;\n}\n.mediaUploads .card:hover {\n  /* transform: translateY(-6px); */\n  transition: 0.3s ease;\n  scale: 1.02;\n}\n\n.mediaUploads .images-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n\n  @media (max-width: 1074px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n.mediaUploads .video-grid,\n.mediaUploads .catalogue-section {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n\n  @media (max-width: 1074px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n.mediaUploads .videoCard {\n  justify-content: flex-start;\n}\n.mediaUploads .mainData {\n  display: flex;\n  gap: 20px;\n  margin: 20px 0;\n  background: #e0dfdf73;\n  padding: 20px;\n  border-radius: 12px;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n  }\n  @media (max-width: 450px) {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n.mediaUploads .mainData .contents {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  justify-content: center;\n\n  p {\n    width: 100%;\n  }\n}\n.mediaUploads .mainData img {\n  width: clamp(240px, 15vw, 400px);\n  border-radius: 12px;\n}\n\n.mediaUploads .frame-two {\n  background: #e0dfdf73;\n  padding: 20px;\n  border-radius: 12px;\n}\n/* \n.mediaUpload .body {\n  display: unset;\n  background: rgba(234, 229, 229, 0.172);\n} */\n\n.mediaUpload .select-container {\n  margin-top: 10px;\n}\n\n.mediaUpload .selectIndustry {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n  width: 100%;\n  margin-top: 10px;\n  align-items: end;\n\n  @media(max-width: 992px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.mediaUpload .selecttype{\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n  width: 100%;\n  margin-top: 10px;\n  text-align: left;\n}\n\n.mediaUpload .form-header{\n  display: grid;\n   grid-template-columns: 1fr 1fr;\n   gap: 20px;\n\n   @media(max-width: 992px) {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
